<template>
  <div class="logisticsDetail">
    <van-cell
      v-if="logisticsDetail.name"
      :value="logisticsDetail.name"
      title="物流公司"
    />

    <van-cell-group v-for="(exp, index) of express100Detail" :key="index">
      <van-cell :value="exp.no" title="物流单号" />
      <van-steps :active="0" direction="vertical">
        <van-step v-for="(item, index) in exp.steps" :key="index">
          <h3>{{ item.context }}</h3>
          <p>{{ item.time }}</p>
        </van-step>
      </van-steps>
    </van-cell-group>

    <van-cell-group v-for="(img, index) of imgs" :key="index">
      <van-cell
        v-if="img && img.length > 0"
        :title="'发货信息' + (index + 1)"
        value="查看图片"
        @click="onLogistcsImg(img)"
      />
    </van-cell-group>
  </div>
</template>

<script>
import { queryExpress100 } from "@/api/goods-api";
import { ImagePreview } from "vant";

export default {
  name: "express-info",
  data() {
    return {
      show: false,
      logisticsDetail: null,
      express100Detail: [],
      imgs: [],
    };
  },

  props: { expInfo: { type: Object, required: true } },

  created() {
    this.init();
  },

  methods: {
    init() {
      this.logisticsDetail = this.expInfo;
      const ids = this.logisticsDetail.no
        .split(/\s+/)
        .filter((item) => item !== "");
      budo_log.info("#54 init logisticsDetail ids", ids);

      for (const id of ids) {
        if (id && id !== "undefined") {
          queryExpress100(this.logisticsDetail.code, id).then((res) => {
            if (res && res.data) {
              this.express100Detail.push({ no: id, steps: res.data });
            } else {
              this.express100Detail.push({
                no: id,
                steps: [{ time: "", context: res.message }],
              });
            }
          });
        }
      }

      if (this.logisticsDetail.img && this.logisticsDetail.img.length > 0) {
        this.imgs = this.logisticsDetail.img.split(",");
      }
    },
    onLogistcsImg(img) {
      ImagePreview([img]);
    },

    // 返回
    returnClick() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.logisticsDetail {
  height: 300px;
  overflow-y: auto;

  /deep/ .van-card:not(:first-child) {
    margin-top: 0;
  }

  h3 {
    font-size: 12px;
    padding: 0;
    margin: 0;
  }

  p {
    padding: 0;
    margin: 0;
    font-size: 12px;
  }

  .img {
    width: 100%;
    padding: 0 10px;
    box-sizing: border-box;
    position: fixed;
    bottom: 10px;
  }

  .header {
    position: fixed;
    top: 0;
    width: 100%;
    height: 44px;
    line-height: 44px;
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    background: #f7f7f8;
    z-index: 100;

    .van-icon-arrow-left {
      float: left;
      margin: 11px 0 0 8px;
      font-size: 22px;
    }
  }
}
</style>
